import AllCities from './AllCities';

export default AllCities;
